import { useRef, ChangeEvent, KeyboardEvent, useEffect, useState } from "react";
import { XButtonForm } from "src/components/common/form/XButtonForm";
import ReactDOM from 'react-dom';
import { DateRange } from "react-day-picker";
import { formatDate } from "src/utils/string/stringUtil";
import DateRangePicker from "src/components/common/calendar/DateRangePicker";
import { searchFormString, searchDateRangeFormString, gridCalendarHeight, gridCalendarWidth, gridCalendarLayoutHeight, searchFieldWidth, searchLabelStyle, dateRangePickerFormLabelStyle, dateRangePickerFormString, dateRangePickerFieldWidth, titleMRClass, dateRangePickerFieldString } from "src/components/common/common";

interface Props {
	label: string;
	wrapperOption?: {
		wrapperStyle?: string;
		titleStyle?: string;
		dateRangeStyle?: string;
	}
	visible: boolean;									setVisible: (visible: boolean) => void;
	editable: boolean;
	titleless?: boolean;
	dateRange: DateRange | undefined,					setDateRange: (dateRange: DateRange | undefined) => void;
	pickerPosition: { top: number; left: number };		setPickerPosition: (pickerPosition: { top: number; left: number }) => void;
}

const DateRangePickerForm = ( props: Props ) => {
 
	const {
		label = "라벨",
		wrapperOption = {
			wrapperStyle: dateRangePickerFieldWidth,
			titleStyle: dateRangePickerFormLabelStyle,
			dateRangeStyle: dateRangePickerFieldString,
		},
		visible, setVisible,
		editable,
		titleless,
		dateRange, setDateRange,
		pickerPosition, setPickerPosition,
	} = props;

	const inputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {

		if (visible && inputRef.current) {
			const rect = inputRef.current.getBoundingClientRect();
            const pTagWidth = rect.width;
            const newLeft = rect.left - (pTagWidth / 2) + window.scrollX;
			setPickerPosition({
				top: rect.bottom + window.scrollY,
				left: newLeft, 
			});
		}
	}, [visible]);
	
	return (
		<>
		<div className={`${ dateRangePickerFormString } ${ wrapperOption?.wrapperStyle || '' } ${editable ? 'cursor-pointer' : ''}`}
			onClick={() => editable && setVisible(true)}
		>
				<p className={`${wrapperOption.titleStyle} form-title ${titleMRClass} ${editable ? 'cursor-pointer' : ''} ${titleless ? 'hidden' : ''}`}
							onClick={() => inputRef.current?.focus()} 
							tabIndex={ editable ? 0 : -1}
							>
					{label}
				</p>
				<div className="relative flex flex-col" style={{ position: 'relative' }}>
					{/* 날짜 선택 영역(클릭 시 달력 팝업) */}
					<p className={`${ wrapperOption?.dateRangeStyle || searchDateRangeFormString } ${editable ? 'cursor-pointer' : 'bg-gray-disable'}`}
						// style={ !editable ? { border: '1px solid rgb(212, 212, 212)' } : {} }
						onClick={(e) =>{ e.stopPropagation(); if(editable) setVisible(true); }}
						ref={inputRef}
						title={dateRange?.from ? `${formatDate(dateRange.from)} ~ ${dateRange.to ? formatDate(dateRange.to) : ""}` : "날짜를 선택해주세요."}
						>

						{dateRange?.from
							? `${formatDate(dateRange.from)} ~ ${dateRange.to ? formatDate(dateRange.to) : ""}`
							: "날짜를 선택해주세요."}
					</p>
					{/* 달력 팝업 */}
					{visible &&
						ReactDOM.createPortal(
						<>
							<div
							style={{
								position: 'fixed',
								top: 0,
								left: 0,
								width: gridCalendarWidth,
								height: gridCalendarLayoutHeight,
								zIndex: 9998,
								// backgroundColor: 'rgba(0,0,0,0.1)', // 필요시 반투명 배경 추가
							}}
							onClick={(e) => {
								e.stopPropagation();
								setVisible(false);
							}}
							/>
							<div
								style={{
									position: 'absolute',
									top: `${pickerPosition.top}px`,
									left: `${pickerPosition.left}px`,
									zIndex: 9999, // DateRangePicker z-index
								}}
							>
							<DateRangePicker
								from={dateRange?.from}
								to={dateRange?.to}
								onChange={(range: DateRange) => {
									setDateRange({
										from: range.from,
										to: range.to,
									});
								}}
								onCancel={() => setVisible(false)}
								onConfirm={(range: DateRange) => {
									setDateRange({
										from: range.from,
										to: range.to,
									});
									setVisible(false); // <- 이 함수가 모달을 닫아야 함
								}}
							/>
							</div>
						</>,
						document.body
						)}
				</div>
			</div>
		</>
	)
}

export default DateRangePickerForm;